import { Instagram, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

// Sparkle-ın öz şəkilləri. Sayt üçün 800px-ə kiçildilib (orijinallar
// `~/Desktop` qovluğunda saxlanılır). Yenisini əlavə edəndə eyni ölçüyə sal.
import shot1 from "../assets/gallery/1.jpg";
import shot2 from "../assets/gallery/2.jpg";
import shot3 from "../assets/gallery/3.jpg";
import shot4 from "../assets/gallery/4.jpg";
import shot5 from "../assets/gallery/5.jpg";
import shot6 from "../assets/gallery/6.jpg";

const SHOTS = [shot1, shot2, shot3, shot4, shot5, shot6];

export const InstagramGallery = () => {
  const { t, lang } = useLanguage();
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-24" data-testid="instagram-gallery">
      <div className="flex flex-col items-center text-center mb-12">
        <p className="overline mb-3">{lang === "en" ? "Follow us" : "Bizi izləyin"}</p>
        <a
          href="https://instagram.com/sparklebaku"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-handle-link"
          className="font-serif font-light text-4xl sm:text-5xl tracking-tight inline-flex items-center gap-3 hover:text-brand-sub transition-colors"
        >
          <Instagram size={32} strokeWidth={1.25} /> @sparklebaku
        </a>
        <p className="mt-4 text-sm text-brand-sub font-light max-w-md">
          {lang === "en"
            ? "Discover our latest silver pieces on Instagram."
            : "Ən son gümüş kolleksiyamızı Instagram-da kəşf edin."}
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {SHOTS.map((src, i) => (
          <a
            key={i}
            href="https://instagram.com/sparklebaku"
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`instagram-shot-${i}`}
            className="group relative aspect-square overflow-hidden bg-brand-bg2"
          >
            <img
              src={src}
              alt="Sparkle"
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-brand-ink/0 group-hover:bg-brand-ink/40 transition-colors flex items-center justify-center">
              <ArrowUpRight size={26} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
